import { Link } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { buttonVariants } from "@/components/ui/button";

export type BookingReturnContext = {
  token: string;
  path: string;
  kind?: "booking" | "proposal";
} | null;

export function BookingReturnField({
  context,
}: {
  context?: BookingReturnContext;
}) {
  return context ? (
    <input type="hidden" name="booking_return" value={context.token} />
  ) : null;
}

export default function BookingSetupReturn({
  context,
}: {
  context?: BookingReturnContext;
}) {
  const { t } = useTranslation();
  if (!context) return null;
  return (
    <aside className="flex flex-wrap items-center justify-between gap-3 rounded-lg border bg-muted/40 p-4">
      <p className="text-sm">
        {t(
          context.kind === "proposal"
            ? "product_ux_booking.proposal_setup_return_help"
            : "product_ux_booking.setup_return_help",
        )}
      </p>
      <Link
        className={buttonVariants({ variant: "outline" })}
        href={context.path}
      >
        {t(
          context.kind === "proposal"
            ? "product_ux_booking.return_to_proposal"
            : "product_ux_booking.return_to_booking",
        )}
      </Link>
    </aside>
  );
}
